import { render } from "./StaticMap.vue?vue&type=template&id=178416a6&scoped=true"
import script from "./StaticMap.vue?vue&type=script&lang=js"
export * from "./StaticMap.vue?vue&type=script&lang=js"

import "./StaticMap.vue?vue&type=style&index=0&id=178416a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-178416a6"

export default script